import { Instagram, Mail, MapPin } from "lucide-react";
import { Fade, MaskedLines, Reveal } from "@/components/motion";
import { SITE } from "@/lib/site";

export default function Contact() {
    return (
        <div data-testid="contact-page" className="mx-auto max-w-7xl px-5 pb-24 pt-44 sm:px-8">
            <Fade delay={0.1}>
                <p className="eyebrow">Contact</p>
            </Fade>
            <h1 className="mt-5 font-serif text-4xl font-light leading-tight tracking-tight text-ivory sm:text-6xl">
                <MaskedLines lines={["One inbox,", "no call centres."]} />
            </h1>
            <Fade delay={0.7}>
                <p className="mt-6 max-w-xl text-sm leading-relaxed text-mist sm:text-base">
                    Whether you're a buyer with a question about the platform or a developer
                    ready to showcase a project, write to us — a human replies.
                </p>
            </Fade>

            <div className="mt-14 grid gap-5 md:grid-cols-3">
                <Reveal>
                    <a
                        href={`mailto:${SITE.email}`}
                        data-testid="contact-email-card"
                        className="group flex h-full flex-col rounded-3xl border border-black/8 bg-card p-8 transition-colors hover:border-gold/40"
                    >
                        <Mail className="h-6 w-6 text-gold" strokeWidth={1.5} />
                        <h2 className="mt-6 font-serif text-2xl text-ivory">Email</h2>
                        <p className="mt-2 text-sm text-mist">For everything — buyers, developers, press.</p>
                        <p className="mt-auto pt-6 text-sm font-medium text-gold">{SITE.email}</p>
                    </a>
                </Reveal>
                <Reveal delay={0.1}>
                    <a
                        href={SITE.instagram}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="contact-instagram-card"
                        className="group flex h-full flex-col rounded-3xl border border-black/8 bg-card p-8 transition-colors hover:border-gold/40"
                    >
                        <Instagram className="h-6 w-6 text-gold" strokeWidth={1.5} />
                        <h2 className="mt-6 font-serif text-2xl text-ivory">Instagram</h2>
                        <p className="mt-2 text-sm text-mist">Follow new showcases and city launches.</p>
                        <p className="mt-auto pt-6 text-sm font-medium text-gold">@sthaan.space</p>
                    </a>
                </Reveal>
                <Reveal delay={0.2}>
                    <div
                        className="flex h-full flex-col rounded-3xl border border-black/8 bg-card p-8"
                        data-testid="contact-office-card"
                    >
                        <MapPin className="h-6 w-6 text-gold" strokeWidth={1.5} />
                        <h2 className="mt-6 font-serif text-2xl text-ivory">Registered Office</h2>
                        <p className="mt-2 text-sm leading-relaxed text-mist">
                            {SITE.company}
                            <br />
                            CIN: {SITE.cin}
                        </p>
                        <p className="mt-auto pt-6 text-xs leading-relaxed text-dim">{SITE.address}</p>
                    </div>
                </Reveal>
            </div>

            <Reveal delay={0.1}>
                <div className="mt-10 rounded-3xl border border-black/5 bg-surface/40 p-8">
                    <h2 className="font-serif text-xl text-ivory">Looking for project details?</h2>
                    <p className="mt-3 max-w-2xl text-sm leading-relaxed text-mist">
                        Sthaan connects buyers directly with developers. For pricing,
                        availability, site visits or documentation, use the WhatsApp button
                        on the project page — your enquiry goes straight to the developer's
                        team. For everything else, {SITE.email} is the only inbox.
                    </p>
                </div>
            </Reveal>
        </div>
    );
}
